import { formatDistanceToNow } from 'date-fns';
import { AlertTriangle, CheckCircle2, Loader2 } from 'lucide-react';

export interface SubmitFooterSaveIndicatorProps {
  isSaving: boolean;
  isDirty: boolean;
  lastSaved: Date | null;
}

/** "Saving… / Unsaved changes / Saved <time> ago" indicator next to the action buttons. */
export function SubmitFooterSaveIndicator({ isSaving, isDirty, lastSaved }: SubmitFooterSaveIndicatorProps) {
  return (
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground flex-shrink-0">
      {isSaving ? (
        <span className="flex items-center gap-1.5 text-muted-foreground">
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
          Saving…
        </span>
      ) : isDirty ? (
        <span className="flex items-center gap-1.5 text-amber-600">
          <AlertTriangle className="h-3.5 w-3.5" />
          Unsaved changes
        </span>
      ) : lastSaved ? (
        <span className="flex items-center gap-1.5 text-green-600">
          <CheckCircle2 className="h-3.5 w-3.5" />
          Saved {formatDistanceToNow(lastSaved, { addSuffix: true })}
        </span>
      ) : null}
    </div>
  );
}
